<template>
  <div class="box5">
    <div class="top-box">
      <pageTitle title="计算机科学硕士" text="Master's in Computer Science" />  
      <!-- <div v-show="!isSticky" class="nav-box">
        <div
          class="nav"
          v-for="(item, index) in navList"
          :key="index"
          :class="{ 'cur-nav': cur == index }"
          @click="changeCur(index)"
          ref="nav"
        >
          <h3>{{ item.title }}</h3>
          <p>{{ item.english }}</p>
        </div>
      </div>
      <div v-show="isSticky" class="nav-box sticky">
        <div
          class="nav"
          v-for="(item, index) in navList"
          :key="index"
          :class="{ 'cur-nav': cur == index }"
          @click="changeCur(index)"
          ref="nav"
        >
          <h3>{{ item.title }}</h3>
          <p>{{ item.english }}</p>
        </div>
      </div> -->
    </div>
    <!-- 计算机科学硕士 -->
    <div class="content-box" v-if="cur === 0">
      <div class="con-box">
        <div class="title-btn"><p>专业详情</p></div>
        <div class="main-top-pic">
          <p>史蒂文斯理工学院计算机科学硕士（MSCS）全球知名，2023 年 USNews 排名全美前 8，课程契合多高需领域。毕业生多入苹果、谷歌、华为等巨头，或创业、深造。此校该专业于信息时代职业发展机遇优，计算机高级人才稀缺，去向集中于亚马逊、Meta、IBM、美国银行、谷歌、摩根大通。</p>
        </div>
        <div class="table-box">
          <div class="list-header">
            <p>职位</p>
            <p>从业人数</p>
            <p>年收入中位数</p>
          </div>
          <div class="list-item" v-for="(item, index) in majorList" :key="index">
            <p>{{ item.job }}</p>
            <p>{{ item.number }}</p>
            <p>{{ item.income }}</p>
          </div>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>课程内容</p></div>
        <div class="title-text">以下是计算机科学硕士课程的核心和高阶课程，<br/>毕业需完成10门课程，30学分的学习</div>
        <div class="con-list">
          <div class="head-title">基础课</div>
          <div class="list-item" v-for="(item, index) in leftList" :key="index">
            <div class="left-code">{{ item.code }}</div>
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
        <div class="con-list">
          <div class="head-title">进阶课</div>
          <div class="list-item" v-for="(item, index) in rightList" :key="index">
            <div class="left-code">{{ item.code }}</div>
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>学习模式</p></div>
        <div class="list-box">
          <div class="list-item" v-for="(item, index) in list" :key="index">
            <img class="left-icon" :src="item.icon" />
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>商科教授</p></div>
        <div class="teacher-list-box">
          <div class="list-item" v-for="(item, index) in teacherList" :key="index">
            <div class="item-icon"></div>
            <div class="item-top">
              <img class="left-pic" :src="item.pic" />
              <div class="right-text">
                <div class="job">{{ item.job }}</div>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>
            <div v-if="item.education" class="education">{{ item.education }}</div>
            <div class="description">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 数据科学硕士 -->
    <div class="content-box content-box2" v-if="cur === 1">
      <div class="con-box">
        <div class="title-btn"><p>专业详情</p></div>
        <div class="main-top-pic">
          <p>史蒂文斯理工学院数据科学硕士（MSDS）全球知名。十年间，数据科学人才需求大增，美劳工局预计至 2031 年该领域就业增 36%，年均 1.35 万新职缺。加州等州数据科学家集中，也有不少远程高薪岗。此硕士专注培育技术、分析与应用技能，适配金融科技等多领域。数据科学人才稀缺，该校毕业生多就职于亚马逊、谷歌、Meta、IBM 等及高校。</p>
        </div>
        <div class="table-box">
          <div class="list-header">
            <p>职位</p>
            <p>年收入中位数</p>
          </div>
          <div class="list-item" v-for="(item, index) in majorList2" :key="index">
            <p>{{ item.job }}</p>
            <p>{{ item.income }}</p>
          </div>
          <p class="tips">来源:美国劳工统计局，2022年，2023年</p>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>课程内容</p></div>
        <div class="title-text">以下是数据科学硕士课程的核心和高阶课程学生将参与以下课程，毕业需完成10门课程，30学分的学习</div>
        <div class="con-list">
          <div class="head-title">基础课</div>
          <div class="list-item" v-for="(item, index) in leftList2" :key="index">
            <div class="left-code">{{ item.code }}</div>
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
        <div class="con-list">
          <div class="head-title">进阶课</div>
          <div class="list-item" v-for="(item, index) in rightList2" :key="index">
            <div class="left-code">{{ item.code }}</div>
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>学习模式</p></div>
        <div class="list-box">
          <div class="list-item" v-for="(item, index) in list" :key="index">
            <img class="left-icon" :src="item.icon" />
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>商科教授</p></div>
        <div class="teacher-list-box">
          <div class="list-item" v-for="(item, index) in teacherList2" :key="index">
            <div class="item-icon"></div>
            <div class="item-top">
              <img class="left-pic" :src="item.pic" />
              <div class="right-text">
                <div class="job">{{ item.job }}</div>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>
            <div v-if="item.education" class="education">{{ item.education }}</div>
            <div class="description">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    return {
      cur: 0,
      isSticky: false,
      navList: [
        {
          title: "计算机科学硕士", 
          english: "Master's in Computer Science"
        }, 
        {
          title: "数据科学硕士", 
          english: "Master's in Data Science"
        }, 
      ],
      majorList: [
        {
          job: '计算机和信息系统经理',
          number: '467,000',
          income: '$151,000',
        },
        {
          job: '计算机与信息研究科学家',
          number: '33,000',
          income: '$127,000',
        },
        {
          job: '计算机网络架构师',
          number: '161,000',
          income: '$117,000',
        },
        {
          job: '软件开发人员/软件质量保证分析师/测试人员',
          number: '1,548,000',
          income: '$110,000',
        },
        {
          job: '信息安全分析师',
          number: '145,000',
          income: '$104,000',
        },
        {
          job: '计算机系统分析师',
          number: '583,000',
          income: '$94,000',
        },
      ],
      majorList2: [
        {
          job: '数据科学家职业',
          income: '$100,910',
        },
        {
          job: '机器学习工程师',
          income: '$111,630',
        },
        {
          job: '数据分析师',
          income: '$83,300', 
        },
        {
          job: '数据工程师',
          income: '$92,450', 
        },
        {
          job: '计算机与信息研究科学家',
          income: '$131,490', 
        },
        {
          job: '计算机系统分析师',
          income: '$99,270', 
        },
        {
          job: '大数据架构师',
          income: '$123,430',
        }
      ],
      leftList: [
        {
          code: 'CS 501',
          name: 'Java编程导论',
          description: 'Introduction to java Programming'
        },
        {
          code: 'CS 570',
          name: '数据结构',
          description: 'Data Structures'
        },
      ],
      leftList2: [
        {
          code: 'MA 574',
          name: '数据科学基础数学',
          description: 'Foundational Mathematics for Data Science'
        },
        {
          code: 'MA 540',
          name: '概率论',
          description: 'Probability'
        },
      ],
      rightList: [
        {
          code: 'CS 590',
          name: '算法',
          description: 'Algorithms'
        },
        {
          code: 'CS 525',
          name: '系统编程',
          description: 'Systems Programming'
        },
        {
          code: 'CS 550',
          name: '计算机组织与编程',
          description: 'Computer Organization&Programming'
        },
        {
          code: 'CS 561',
          name: '数据库管理系统I',
          description: 'Database Management Systems l'
        },
        {
          code: 'CS 520',
          name: '操作系统导论',
          description: 'Introduction to Operating Systems'
        },
        {
          code: 'CS 546',
          name: '网页编程',
          description: 'Web Programming'
        },
        {
          code: 'CS 522',
          name: '移动系统与应用',
          description: 'Mobile Systems and Applications'
        },
        {
          code: 'CPE 695',
          name: '应用机器学习',
          description: 'Applied Machine Learning'
        },
      ],
      rightList2: [
        {
          code: 'MA 541',
          name: '统计方法',
          description: 'Statistical Methods'
        },
        {
          code: 'MA 544',
          name: '大数据线性代数',
          description: 'Numerical Linear Algebra for Big Data'
        },
        {
          code: 'MA 576',
          name: '数据科学优化',
          description: 'Optimization for Data science'
        },
        {
          code: 'CPE 695',
          name: '机器学习',
          description: 'Applied Machine Learning'
        },
        {
          code: 'CS 583', 
          name: '深度学习',
          description: 'Deep Learning'
        },
        {
          code: 'MA 641',
          name: '时间序列分析',
          description: 'Time Series Analysis'
        },
        {
          code: 'BIA 662',
          name: '认知计算',
          description: 'Cognitive Computing'
        },
        {
          code: 'BIA 678',
          name: '大数据技术',
          description: 'Big Data Technologies'
        }
      ],
      list: [
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon1.png'),
          name: '上课形式',
          description: '纯线上学习，含院校教授的录播视频及学习材料，支持在线答疑互动，资深教务老师全程跟进学习进度，提供科学指导。'
        },
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon2.png'),
          name: '考核标准',
          description: '教授根据学生作业完成情况、考试综合表现评判得分，总成绩合格，获得全部学分。'
        },
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon3.png'),
          name: '毕业方案',
          description: '学生修满学分，可获得国外院校颁发的学位证书。学生可前往学校参加毕业典礼，或通过邮寄的形式获取学位证书。'
        },
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon4.png'),
          name: '课后活动',
          description: '定期组织课后答疑、研讨会、学习互助小组及线下活动等。'
        },
      ],
      teacherList: [
        {
          pic: require('../../../assets/coursePage/stevens/box5/pic1.png'),
          job: '计算机科学系副教授',
          name: 'Dominic Duggan',
          education: '',
          description: 'IEEE计算机学会会员，在面向大型编程的模块系统、安全动态库更新的软件适应性、面向对象语言等方面进行深入研究'
        }, 
        {
          pic: require('../../../assets/coursePage/stevens/box5/pic2.png'),
          job: '助理教授兼研究生院副主任',
          name: 'Shudong Hao',
          education: '科罗拉多大学波尔德分校计算机科学博士学位',
          description: '研究旨在开发自然语言处理算法，用于处理、组织和保护少数语言中的大型数据集'
        }, 
        {
          pic: require('../../../assets/coursePage/stevens/box5/pic3.png'),
          job: '计算机科学系教授兼本科生研究副主任',
          name: 'Samuel Kim',
          education: '史蒂文斯理工学院计算机科学博士学位',
          description: '教授并设计多门研究生课程:数据库管理系统、数据仓库、面向对象数据库管理、计算机体系结构和C++面向对象设计和编程'
        }, 
        {
          pic: require('../../../assets/coursePage/stevens/box5/pic4.png'),
          job: '计算机科学系讲师',
          name: 'Reza Pevrovian',
          education: '迈阿密大学数学与计算机科学博士学位',
          description: '曾担任国际货币基金组织(IMF)、世界银行国际开发署和美国商务部顾问，中国人民大学东京大学、名古屋大学客座教授。现任芝加哥大学中国研究小组成员。新华社、人民日报、中央电视台多次采访，并在《新闻联播》播出。'
        }, 
      ],
      teacherList2: [
        {
          pic: require('../../../assets/coursePage/stevens/box5/pic5.png'),
          job: '数学科学系教授、 系主任',
          name: 'Michael Zabarankin',
          education: '佛罗里达大学量化金融博士、基辅国立大学应用数学博士、曾任佛罗里达大学访问助理教授',
          description: '研究兴趣集中于逆向优化、机器学习、和风险分析'
        }, 
        {
          pic: require('../../../assets/coursePage/stevens/box5/pic6.png'),
          job: '教学教授、研究生院前副系主任',
          name: 'Eduardo Bonelli',
          education: '巴黎第十一大学计算机博士、2022年杰出教师奖，2019年杰出教学副教授',
          description: '研究兴趣集中于Lambda演算、类型理论、证明理论、重写理论'
        }, 
        {
          pic: require('../../../assets/coursePage/stevens/box5/pic7.png'),
          job: '数学科学系教授、前系主任，教务委员会主席',
          name: 'Darinka Dentcheva',
          education: '德国洪堡大学数学培训、数学双博士',
          description: '研究兴趣集中于随机系统优化和最优控制，风险和风险规避优化的数学模型，统计学，数值技术'
        }, 
        {
          pic: require('../../../assets/coursePage/stevens/box5/pic8.png'),
          job: '讲师',
          name: 'Upendra Prasad',
          education: '康涅狄格大学数学博士、曾在哈佛大学、凯斯西储大学任教',
          description: '研究兴趣集中于数值线性代数、机器学习和数据科学、数学生物学'
        }, 
      ]
    };
  },

  // mounted() {
  //   // 监听窗口滚动事件
  //   window.addEventListener('scroll', this.handleScroll);
  // },
  // beforeDestroy() {
  //   // 移除滚动事件监听器
  //   window.removeEventListener('scroll', this.handleScroll);
  // },
  methods: {
    changeCur(index) {
      this.cur = index;
      // 获取 nav-box 元素
      const navBox = this.$el;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (navBox) {
        // 获取 nav-box 元素的顶部位置
        const navBoxTop = navBox.getBoundingClientRect().top + scrollTop + 90;
        // 滚动到 nav-box 元素的位置
        window.scrollTo({
          top: navBoxTop,
          behavior: 'smooth' // 平滑滚动
        });
      }
    },
    handleScroll() {
      // 获取 .nav-box 元素和 .box5 元素
      const navBox = this.$el.querySelector('.nav-box');
      const box5 = this.$el;
      const navBoxTop = navBox.getBoundingClientRect().top;
      const box5Top = box5.getBoundingClientRect().top;
      const box5Bottom = box5.getBoundingClientRect().bottom;
      // 当滚动位置超过 .nav-box 元素的顶部位置且在 box5 区域内时，添加 sticky 类
      this.isSticky = navBoxTop <= 0 && box5Top <= 0 && box5Bottom > 0;
    }
  }
};
</script>

<style lang="less" scoped>
.box5 {
  position: relative;
  // background: #F4F4FB; 
  .top-box {
    box-sizing: border-box;
    padding: 80px 0 0;
    width: 100%;
    height: 268px;
    background: url("../../../assets/coursePage/stevens/box5/top-title-bg.png") no-repeat;
    background-size: cover;
  }
  /deep/.course-title-box{
    .course-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #FFFFFF;
      line-height: 64px;
    }
    .course-text {
      margin-top: 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 34px;
      color: #FFFFFF;
      line-height: 48px;
    }
  } 
  .nav-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 90px;
    margin: 48px auto 0;
    will-change: position;
    .nav {
      cursor: pointer;
      box-sizing: border-box;
      width: 50%;
      height: 90px;
      text-align: center;
      color: #FFFFFF;
      h3 {
        font-size: 34px;
        line-height: 48px;
      }
      p {
        font-size: 20px;
        line-height: 28px;
      }
    }
    .cur-nav {
      position: relative;
      &::after {
        position: absolute;
        content: '';
        bottom: -16px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 218px;
        height: 14px;
        background: url("../../../assets/coursePage/stevens/box5/selected.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .sticky {
    margin: 0;
    padding-top: 26px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background: #A32738; 
    -webkit-transform: translateZ(0); // 开启硬件加速
    transform: translateZ(0);
    will-change: position; // 提前告知浏览器位置即将变化
    transition: none; // 去除过渡效果
    .cur-nav {
      &::after {
        bottom: -9px; 
      }
    }
  }
  .content-box {
    padding: 32px 40px 80px;
    background: #FFFFFF;
    border-radius: 24px;
    .con-box {
      position: relative;
      margin-bottom: 40px;
      padding-bottom: 40px;
      width: 670px;
      background: #F3F3F9;
      border-radius: 32px;
      .main-top-pic {
        width: 710px;
        height: 384px;
        position: absolute;
        left: -20px;
        right: -20px;
        margin: 0 auto;
        top: 124px;
        background: url("../../../assets/coursePage/stevens/box5/top-bg-pic.png") no-repeat;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        p {
          width: 630px;
          font-weight: 400;
          font-size: 28px;
          color: #FFFFFF;
          line-height: 44px;
          text-align: justify;
        }
      }
      .table-box {
        box-sizing: border-box;
        padding: 548px 40px 0;
        width: 670px;
        display: flex;
        flex-wrap: wrap;
        .list-header {
          padding: 0 0 10px;
          width: 100%;
          height: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          p {
            font-size: 26px;
            color: #A32738;
            line-height: 40px;
          }
          p:first-child {
            width: 270px;
          }
          p:nth-child(2) {
            width: 112px;
            text-align: right;
          }
          p:last-child {
            width: 160px;
            text-align: right; 
          }
        }
        .list-item {
          width: 100%;
          height: 96px;
          padding: 28px 0;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #DBDBEB;
          p {
            font-size: 24px;
            color: #272020;
            line-height: 40px;
          }
          p:first-child {
            width: 270px;
          }
          p:nth-child(2) {
            width: 112px;
            text-align: right;
          }
          p:last-child {
            width: 160px;
            text-align: right; 
          }
        }
        .list-item:nth-child(5) {
          height: 136px;
        }
      }
    }
    .title-btn {
      box-sizing: border-box;
      position: absolute;
      top: 24px;
      left: -16px;
      padding: 8px 0 0 42px;
      width: 256px;
      height: 76px;
      background: url("../../../assets/coursePage/stevens/box5/title-bg.png") no-repeat;
      background-size: 100% 100%;
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #A32738;
        line-height: 48px;
        text-align: left;
      }
    }
    .title-text {
      padding: 124px 40px 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #272020;
      line-height: 44px;
      text-align: left;
    }
    .con-list {
      margin: 32px auto 0;
      font-family: PingFangSC, PingFang SC;
      width: 590px;
      .head-title {
        margin-bottom: 24px;
        width: 590px;
        height: 80px;
        background: #FFFFFF;
        border-radius: 16px;
        font-weight: 600;
        font-size: 32px;
        color: #272020;
        line-height: 80px;
        text-align: center;
      }
      .list-item {
        position: relative;
        padding: 24px 0;
        display: flex;
        justify-content: flex-start;
        &::after {
          position: absolute;
          content: '';
          display: block;
          bottom: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
          width: 590px;
          border-bottom: 1px solid #DADCE4;
        }
        .left-code {
          width: 138px;
          font-weight: bold;
          font-size: 28px;
          color: #272020;
          line-height: 44px;
          text-align: left;
        } 
        .right-text {
          .name {
            font-weight: 400;
            font-size: 28px;
            color: #272020;
            line-height: 44px;
            text-align: left;
          }
          .description {
            font-weight: 400;
            font-size: 24px;
            color: #BC5F5F;
            line-height: 40px;
            text-align: left;
          }
        }
      }
    }
    .list-box {
      padding: 124px 32px 0;
      .list-item {
        margin: 0 auto 24px;
        box-sizing: border-box;
        position: relative;
        padding: 40px 32px;
        display: flex;
        justify-content: flex-start;
        width: 606px;
        background: #FFFFFF;
        border-radius: 19px;
        .left-icon {
          width: 48px;
          height: 48px;
          margin-right: 24px;
        } 
        .right-text {
          .name {
            font-weight: 600;
            font-size: 32px;
            line-height: 48px;
            color: #272020;
            text-align: left;
          }
          .description {
            margin-top: 16px;
            font-weight: 400;
            font-size: 26px;
            color: #847D7D;
            line-height: 40px;
            text-align: left;
          }
        }
      } 
      .list-item:last-child {
        margin-bottom: 0;
      }
    }
    .teacher-list-box {
      box-sizing: border-box;
      padding: 124px 32px 0;
      width: 670px;
      border-radius: 32px;
      .list-item {
        margin-bottom: 24px;
        position: relative;
        padding: 40px;
        border-radius: 26px;
        background: #FAFAFD;
        .item-icon {
          position: absolute;
          top: 0;
          right: 0;
          width: 72px;
          height: 72px;
          background: url('../../../assets/coursePage/stevens/box5/bg-icon.png') no-repeat;
          background-size: cover;
        }
        .item-top {
          display: flex;
          justify-content: flex-start;
          margin-bottom: 32px;
        }
        .left-pic {
          width: 216px;
          height: 216px;
          margin-right: 40px;
        } 
        .right-text {
          .name {
            font-weight: 600;
            font-size: 40px;
            color: #272020;
            line-height: 52px;
            text-align: left;
          }
          .job {
            margin-top: 64px;
            font-weight: 400;
            font-size: 28px;
            color: #A32738;
            line-height: 44px;
            text-align: left;
          }
        }
        .education {
          position: relative;
          margin-left: 20px;
          font-weight: 600;
          font-size: 28px;
          color: #272020;
          line-height: 44px;
          text-align: left;
          &::before {
            position: absolute;
            content: '';
            top: 16px;
            bottom: 0;
            left: -20px;
            content: '';
            width: 8px;
            height: 8px;
            background: #A32738;
            border-radius: 50%;
          }
        }
        .description {
          margin-top: 24px;
          font-weight: 400;
          font-size: 26px;
          color: #847D7D;
          line-height: 40px;
          text-align: left;
        }
      }
      .list-item:nth-child(2), .list-item:nth-child(3) {
        .right-text {
          .job {
            margin-top: 72px;
          }
        }
      }
      .list-item:last-child {
        margin-bottom: 0; 
      }
    }
    .con-box:last-child {
      padding-bottom: 32px;
      margin-bottom: 0;
    } 
  }
  .content-box2 {
    .con-box {
      .main-top-pic {
        height: 472px;
        background: url("../../../assets/coursePage/stevens/box5/top-bg-pic2.png") no-repeat;
        background-size: cover;
      }
      .table-box {
        padding-top: 628px;
        .list-header {
          height: 26px;
        }
        .list-item {
          height: 80px;
        }
        .list-item:nth-child(5) {
          height: 80px;
        }
        .tips {
          margin-top: 24px;
          width: 100%;
          font-size: 24px;
          color: #817878;
          line-height: 40px;
          text-align: center;
        }
      }
      .con-list:nth-child(3) {
        .list-item:nth-child(2) {
          .right-text {
            .description {
              white-space: nowrap;
              font-size: 21.5px;
            }
          }
        }
      }
      .teacher-list-box {
        .list-item {
          .right-text {
            .job {
              margin-top: 16px;
            }
            .name {
              margin-top: 4px;
            }
          }
        }
        .list-item:nth-child(1) {
          .right-text {
            .job {
              width: 240px;
              font-size: 26px;
            }
          }
        }
        .list-item:nth-child(3) {
          .right-text {
            .job {
              font-size: 26px;
            }
          }
        }
        .list-item:nth-child(4) {
          .right-text {
            .job {
              margin-top: 60px;
            }
          }
        } 
      }
    }
  }
}
</style>
